var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category)?_c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"color-box",style:({ 'background-color': _vm.categoryColor(_vm.categoryId) })}),(!_vm.colorOnly)?_c('div',{staticClass:"category-name",staticStyle:{"line-height":"13px"}},[_vm._v(" "+_vm._s(_vm.category.name)+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }